<template>
  <div style="margin-top:5px;">
    <div
      v-if="
        resultList &&
          resultList.length > 0 &&
          resultList[0].CONTENTLIST &&
          resultList[0].CONTENTLIST.length > 0 &&
          resultList[0].CONTENTLIST[0].DATALIST &&
          resultList[0].CONTENTLIST[0].DATALIST.length > 0
      "
    >
      <div
        style="text-align: center; text-align: center;padding: 8px;background: #6f6f6f;color: #fff;"
        v-if="resultList && resultList.length > 0"
      >
        <h4 style="margin: 5px;">
          {{
            resultList[0].CONTENTLIST[0].DATALIST[0].XMQC +
              "(" +
              resultList[0].CONTENTLIST[0].DATALIST[0].XMJC +
              ")"
          }}{{ queryType === "ZXC" ? "秩序册" : "成绩册" }}
        </h4>
      </div>
      <div v-for="(mainItem, mainIndex) in resultList" :key="mainIndex">
        <div
          class="topMainDivClass"
          v-if="mainItem.CONTENTLIST.length > 0"
          v-bind:style="{
            height: mainItem.CONTENTLIST[0].DATALIST.length * 90 + 'px'
          }"
        >
          <h3 style="text-align: center;position: relative;top: -66px;">
            <span>
              <img
                style="width: 25px;"
                src="https://www.ptty.com.cn/wap/jb.png"
              />
            </span>
            {{ mainItem.BJW }}
          </h3>
          <!-- 第1轮 开始 -->
          <div
            style="float:left;"
            v-if="mainItem.CONTENTLIST[0].DATALIST.length > 0"
          >
            <div
              class="divMain1"
              v-for="(item, index) in mainItem.CONTENTLIST[0].DATALIST"
              :key="index"
              v-bind:style="{
                position: 'absolute',
                top: index * (60 + 30) + 'px'
              }"
            >
              <span class="titleSpan1">
                <van-badge
                  :content="item.ZNWZH1.replace('(0)', '')"
                  color="#1989fa"
                >
                </van-badge>
                &nbsp;{{
                  item.ZNWZH1.indexOf("(0)") > -1
                    ? "轮空"
                    : item.RYXM1.length === 0
                    ? item.MCZH1 === "-"
                      ? ""
                      : item.MCZH1.replace("-", "组第")
                    : item.RYXM1 +
                      (item.SSLX.substr(1, 2) === "T"
                        ? ""
                        : "(" + item.DWJC1 + ")")
                }}
              </span>
              <span class="titleSpan2">
                <van-badge
                  :content="item.ZNWZH2.replace('(0)', '')"
                  color="#1989fa"
                >
                </van-badge
                >&nbsp;
                {{
                  item.ZNWZH2.indexOf("(0)") > -1
                    ? "轮空"
                    : item.RYXM2.length === 0
                    ? item.MCZH2 === "-"
                      ? ""
                      : item.MCZH2.replace("-", "组第")
                    : item.RYXM2 +
                      (item.SSLX.substr(1, 2) === "T"
                        ? ""
                        : "(" + item.DWJC2 + ")")
                }}
              </span>
              <div v-if="queryType === 'ZXC'" @click="jumpMxHandler(item.CCH)">
                <span
                  class="spanTitileTopRight"
                  v-if="
                    item.ZNWZH1.indexOf('(0)') === -1 &&
                      item.ZNWZH2.indexOf('(0)') === -1 &&
                      queryType === 'ZXC'
                  "
                >
                  {{ item.RQ.length > 6 ? item.RQ.substr(5, 9) : "" }}

                  {{
                    item.STARTTIME.length === 0 || item.STARTTIME === "-"
                      ? item.CXH.length > 0
                        ? "场序:" + item.CXH
                        : ""
                      : item.STARTTIME
                  }}
                </span>
                <span
                  class="spanTitileBottomRight"
                  v-if="
                    item.ZNWZH1.indexOf('(0)') === -1 &&
                      item.ZNWZH2.indexOf('(0)') === -1 &&
                      queryType === 'ZXC'
                  "
                >
                  {{ item.CDH.length > 0 ? item.CDH + "号场地" : "" }}
                </span>
                <span
                  style="color:red"
                  class="spanTitileBottomLeft1"
                  v-if="
                    item.ZNWZH1.indexOf('(0)') === -1 &&
                      item.ZNWZH2.indexOf('(0)') === -1
                  "
                >
                </span>
                <span
                  style="color:red"
                  class="spanTitileBottomLeft2"
                  v-if="
                    item.ZNWZH1.indexOf('(0)') === -1 &&
                      item.ZNWZH2.indexOf('(0)') === -1
                  "
                >
                  {{ item.SSLXMC }}
                  <!-- {{ item.CCH.substr(item.CCH.length - 3, 11) }} -->
                </span>
                <span
                  style="color:red"
                  class="spanTitileBottomLeft3"
                  v-if="
                    item.ZNWZH1.indexOf('(0)') === -1 &&
                      item.ZNWZH2.indexOf('(0)') === -1
                  "
                >
                </span>
              </div>
              <div v-if="queryType === 'CJC'" @click="jumpMxHandler(item.CCH)">
                <span
                  class="spanTitileTopRight"
                  v-bind:style="{
                    color:
                      item.BSZT === '-1'
                        ? item.ZNWZH1.indexOf('(0)') > -1 ||
                          item.ZNWZH2.indexOf('(0)') > -1
                          ? 'green'
                          : 'black'
                        : item.BSZT === '0'
                        ? 'blue'
                        : 'green'
                  }"
                >
                  {{
                    item.BSZT === "-1"
                      ? item.ZNWZH1.indexOf("(0)") > -1 ||
                        item.ZNWZH2.indexOf("(0)") > -1
                        ? item.ZNWZH1.indexOf("(0)") > -1 &&
                          item.ZNWZH2.indexOf("(0)") === -1
                          ? item.ZNWZH2 + "  " + item.RYXM2
                          : item.ZNWZH1.indexOf("(0)") === -1 &&
                            item.ZNWZH2.indexOf("(0)") > -1
                          ? item.ZNWZH1 + "  " + item.RYXM1
                          : ""
                        : "未开赛"
                      : item.BSZT === "0"
                      ? "比赛中"
                      : item.ISPF1 === "0" && item.ISPF2 === "1"
                      ? item.ZNWZH1 + "  " + item.RYXM1
                      : item.ISPF1 === "1" && item.ISPF2 === "0"
                      ? item.ZNWZH2 + "  " + item.RYXM2
                      : (item.ISPF1 === "1" && item.ISPF2 === "1") ||
                        (item.ISDCQQ1 === "1" && item.ISDCQQ2 === "1")
                      ? "双弃权"
                      : item.ZNWZH1.indexOf("(0)") > -1
                      ? item.ZNWZH2 + "  " + item.RYXM2
                      : item.ZNWZH2.indexOf("(0)") > -1
                      ? item.ZNWZH1 + "  " + item.RYXM1
                      : item.MARK1 > item.MARK2
                      ? item.ZNWZH1 + "  " + item.RYXM1
                      : item.MARK1 === item.MARK2
                      ? item.SC1 > item.SC2
                        ? item.ZNWZH1 + "  " + item.RYXM1
                        : item.SC2 > item.SC1
                        ? item.ZNWZH2 + "  " + item.RYXM2
                        : item.MARK1 > 0 || item.MARK2 > 0
                        ? "比赛中"
                        : "未开赛"
                      : item.ZNWZH2 + "  " + item.RYXM2
                  }}
                </span>

                <!-- 团体赛 比分 显示大比分 开始 -->
                <label v-if="item.SSLX.substr(1, 2) === 'T'">
                  <span
                    class="spanTitileBottomRight"
                    v-if="
                      item.ZNWZH1.indexOf('(0)') === -1 &&
                        item.ZNWZH2.indexOf('(0)') === -1
                    "
                  >
                    {{
                      (item.ISPF1 === "1" || item.ISDCQQ1 === "1"
                        ? "(" + (item.BZ === undefined ? "" : item.BZ) + "弃)"
                        : "") +
                        item.MARK1 +
                        ":" +
                        item.MARK2 +
                        (item.ISPF2 === "1" || item.ISDCQQ2 === "1"
                          ? "(" + (item.BZ === undefined ? "" : item.BZ) + "弃)"
                          : "")
                    }}
                    {{
                      item.SSLX.substr(1, 2) === "T"
                        ? ""
                        : item.MARK1 > 0 &&
                          item.MARK2 > 0 &&
                          item.MARK1 === item.MARK2
                        ? "(" + item.SC1 + ":" + item.SC2 + ")"
                        : ""
                    }}
                  </span>
                </label>
                <!-- 团体赛 比分 显示大比分 结束 -->

                <!-- 单项赛 比分 显示小比分 开始 -->
                <label v-if="item.SSLX.substr(1, 2) !== 'T'">
                  <span
                    class="spanTitileBottomRight"
                    v-if="
                      item.ZNWZH1.indexOf('(0)') === -1 &&
                        item.ZNWZH2.indexOf('(0)') === -1
                    "
                  >
                    {{
                      item.CJMXLIST != undefined && item.CJMXLIST.length > 0
                        ? item.CJMXLIST[0].ISPF1 === "1" ||
                          item.CJMXLIST[0].ISDCQQ1 === "1"
                          ? "(" + (item.BZ === undefined ? "" : item.BZ) + "弃)"
                          : ""
                        : ""
                    }}
                    <label
                      v-for="(cjMxItem, cjMxIndex) in item.CJMXLIST"
                      :key="cjMxIndex"
                    >
                      {{ +cjMxItem.MARK1 + ":" + cjMxItem.MARK2 + "  " }}
                    </label>
                    {{
                      item.CJMXLIST != undefined && item.CJMXLIST.length > 0
                        ? item.CJMXLIST[0].ISPF2 === "1" ||
                          item.CJMXLIST[0].ISDCQQ2 === "1"
                          ? "(" + (item.BZ === undefined ? "" : item.BZ) + "弃)"
                          : ""
                        : ""
                    }}
                  </span>
                </label>
                <!-- 单项赛 比分 显示小比分 结束 -->

                <span
                  style="color:red"
                  class="spanTitileBottomLeft1"
                  v-if="
                    item.ZNWZH1.indexOf('(0)') === -1 &&
                      item.ZNWZH2.indexOf('(0)') === -1
                  "
                >
                  {{ item.CDH.length > 0 ? item.CDH + "号场地" : "" }}
                </span>
                <span
                  style="color:red"
                  class="spanTitileBottomLeft2"
                  v-if="
                    item.ZNWZH1.indexOf('(0)') === -1 &&
                      item.ZNWZH2.indexOf('(0)') === -1
                  "
                >
                  {{ item.RQ }}&nbsp;{{
                    item.STARTTIME === "-" || item.STARTTIME.length === 0
                      ? ""
                      : item.STARTTIME
                  }}
                </span>
                <span
                  style="color:red"
                  class="spanTitileBottomLeft3"
                  v-if="
                    item.ZNWZH1.indexOf('(0)') === -1 &&
                      item.ZNWZH2.indexOf('(0)') === -1
                  "
                >
                  {{ item.SSLXMC }}
                  <!-- {{ item.CCH.substr(item.CCH.length - 3, 11) }} -->
                </span>
              </div>
            </div>
          </div>

          <!-- 第1轮 结束 -->

          <!-- 第2轮 开始  -->
          <div
            style="float:left"
            v-if="
              mainItem.CONTENTLIST[1] !== undefined &&
                mainItem.CONTENTLIST[1].DATALIST.length > 0
            "
          >
            <!-- 正赛 -->
            <div
              class="divMain2"
              v-for="(item, index) in mainItem.CONTENTLIST[1].DATALIST"
              :key="index"
              v-bind:style="{
                position: 'absolute',
                top: index * (60 + 30) * 2 + 31 + 'px'
              }"
            >
              <div v-if="queryType === 'ZXC'" @click="jumpMxHandler(item.CCH)">
                <span
                  class="spanTitileTopRight"
                  v-if="
                    item.ZNWZH1.indexOf('(0)') === -1 &&
                      item.ZNWZH2.indexOf('(0)') === -1 &&
                      queryType === 'ZXC'
                  "
                >
                  {{ item.RQ.length > 6 ? item.RQ.substr(5, 9) : "" }}
                  &nbsp;
                  {{
                    item.STARTTIME.length === 0 || item.STARTTIME === "-"
                      ? item.CXH.length > 0
                        ? "场序:" + item.CXH
                        : ""
                      : item.STARTTIME
                  }}
                </span>
                <span
                  class="spanTitileBottomRight"
                  v-if="
                    item.ZNWZH1.indexOf('(0)') === -1 &&
                      item.ZNWZH2.indexOf('(0)') === -1 &&
                      queryType === 'ZXC'
                  "
                >
                  {{ item.CDH.length > 0 ? item.CDH + "号场地" : "" }}
                </span>
                <span
                  style="color:red"
                  class="spanTitileBottomLeft1"
                  v-if="
                    item.ZNWZH1.indexOf('(0)') === -1 &&
                      item.ZNWZH2.indexOf('(0)') === -1
                  "
                >
                </span>
                <span
                  style="color:red"
                  class="spanTitileBottomLeft2"
                  v-if="
                    item.ZNWZH1.indexOf('(0)') === -1 &&
                      item.ZNWZH2.indexOf('(0)') === -1
                  "
                >
                  {{ item.SSLXMC }}
                  <!-- {{ item.CCH.substr(item.CCH.length - 3, 11) }} -->
                </span>
                <span
                  style="color:red"
                  class="spanTitileBottomLeft3"
                  v-if="
                    item.ZNWZH1.indexOf('(0)') === -1 &&
                      item.ZNWZH2.indexOf('(0)') === -1
                  "
                >
                </span>
              </div>
              <div v-if="queryType === 'CJC'" @click="jumpMxHandler(item.CCH)">
                <span
                  v-bind:style="{
                    color:
                      item.BSZT === '-1'
                        ? item.ZNWZH1.indexOf('(0)') > -1 ||
                          item.ZNWZH2.indexOf('(0)') > -1
                          ? 'green'
                          : 'black'
                        : item.BSZT === '0'
                        ? 'blue'
                        : 'green'
                  }"
                  class="spanTitileTopRight"
                >
                  {{
                    item.BSZT === "-1"
                      ? item.ZNWZH1.indexOf("(0)") > -1 ||
                        item.ZNWZH2.indexOf("(0)") > -1
                        ? item.ZNWZH1.indexOf("(0)") > -1 &&
                          item.ZNWZH2.indexOf("(0)") === -1
                          ? item.ZNWZH2 + "  " + item.RYXM2
                          : item.ZNWZH1.indexOf("(0)") === -1 &&
                            item.ZNWZH2.indexOf("(0)") > -1
                          ? item.ZNWZH1 + "  " + item.RYXM1
                          : ""
                        : "未开赛"
                      : item.BSZT === "0"
                      ? "比赛中"
                      : item.ISPF1 === "0" && item.ISPF2 === "1"
                      ? item.ZNWZH1 + "  " + item.RYXM1
                      : item.ISPF1 === "1" && item.ISPF2 === "0"
                      ? item.ZNWZH2 + "  " + item.RYXM2
                      : (item.ISPF1 === "1" && item.ISPF2 === "1") ||
                        (item.ISDCQQ1 === "1" && item.ISDCQQ2 === "1")
                      ? "双弃权"
                      : item.ZNWZH1.indexOf("(0)") > -1
                      ? item.ZNWZH2 + "  " + item.RYXM2
                      : item.ZNWZH2.indexOf("(0)") > -1
                      ? item.ZNWZH1 + "  " + item.RYXM1
                      : item.MARK1 > item.MARK2
                      ? item.ZNWZH1 + "  " + item.RYXM1
                      : item.MARK1 === item.MARK2
                      ? item.SC1 > item.SC2
                        ? item.ZNWZH1 + "  " + item.RYXM1
                        : item.SC2 > item.SC1
                        ? item.ZNWZH2 + "  " + item.RYXM2
                        : item.MARK1 > 0 || item.MARK2 > 0
                        ? "比赛中"
                        : "未开赛"
                      : item.ZNWZH2 + "  " + item.RYXM2
                  }}
                </span>
                <!-- 团体赛 比分 显示大比分 开始 -->
                <label v-if="item.SSLX.substr(1, 2) === 'T'">
                  <span
                    class="spanTitileBottomRight"
                    v-if="
                      item.ZNWZH1.indexOf('(0)') === -1 &&
                        item.ZNWZH2.indexOf('(0)') === -1
                    "
                  >
                    {{
                      (item.ISPF1 === "1" || item.ISDCQQ1 === "1"
                        ? "(" + (item.BZ === undefined ? "" : item.BZ) + "弃)"
                        : "") +
                        item.MARK1 +
                        ":" +
                        item.MARK2 +
                        (item.ISPF2 === "1" || item.ISDCQQ2 === "1"
                          ? "(" + (item.BZ === undefined ? "" : item.BZ) + "弃)"
                          : "")
                    }}
                    {{
                      item.SSLX.substr(1, 2) === "T"
                        ? ""
                        : item.MARK1 > 0 &&
                          item.MARK2 > 0 &&
                          item.MARK1 === item.MARK2
                        ? "(" + item.SC1 + ":" + item.SC2 + ")"
                        : ""
                    }}
                  </span>
                </label>
                <!-- 团体赛 比分 显示大比分 结束 -->

                <!-- 单项赛 比分 显示小比分 开始 -->
                <label v-if="item.SSLX.substr(1, 2) !== 'T'">
                  <span
                    class="spanTitileBottomRight"
                    v-if="
                      item.ZNWZH1.indexOf('(0)') === -1 &&
                        item.ZNWZH2.indexOf('(0)') === -1
                    "
                  >
                    {{
                      item.CJMXLIST != undefined && item.CJMXLIST.length > 0
                        ? item.CJMXLIST[0].ISPF1 === "1" ||
                          item.CJMXLIST[0].ISDCQQ1 === "1"
                          ? "(" + (item.BZ === undefined ? "" : item.BZ) + "弃)"
                          : ""
                        : ""
                    }}
                    <label
                      v-for="(cjMxItem, cjMxIndex) in item.CJMXLIST"
                      :key="cjMxIndex"
                    >
                      {{ +cjMxItem.MARK1 + ":" + cjMxItem.MARK2 + "  " }}
                    </label>
                    {{
                      item.CJMXLIST != undefined && item.CJMXLIST.length > 0
                        ? item.CJMXLIST[0].ISPF2 === "1" ||
                          item.CJMXLIST[0].ISDCQQ2 === "1"
                          ? "(" + (item.BZ === undefined ? "" : item.BZ) + "弃)"
                          : ""
                        : ""
                    }}
                  </span>
                </label>
                <!-- 单项赛 比分 显示小比分 结束 -->

                <span
                  style="color:red"
                  class="spanTitileBottomLeft1"
                  v-if="
                    item.ZNWZH1.indexOf('(0)') === -1 &&
                      item.ZNWZH2.indexOf('(0)') === -1
                  "
                >
                  {{ item.CDH.length > 0 ? item.CDH + "号场地" : "" }}
                </span>
                <span
                  style="color:red"
                  class="spanTitileBottomLeft2"
                  v-if="
                    item.ZNWZH1.indexOf('(0)') === -1 &&
                      item.ZNWZH2.indexOf('(0)') === -1
                  "
                >
                  {{ item.RQ }}&nbsp;{{
                    item.STARTTIME === "-" || item.STARTTIME.length === 0
                      ? ""
                      : item.STARTTIME
                  }}
                </span>
                <span
                  style="color:red"
                  class="spanTitileBottomLeft3"
                  v-if="
                    item.ZNWZH1.indexOf('(0)') === -1 &&
                      item.ZNWZH2.indexOf('(0)') === -1
                  "
                >
                  {{ item.SSLXMC }}
                  <!-- {{ item.CCH.substr(item.CCH.length - 3, 11) }} -->
                </span>
              </div>
            </div>
          </div>
          <!-- 第2轮 结束 -->

          <!-- 第3轮 开始  -->
          <div
            style="float:left"
            v-if="
              mainItem.CONTENTLIST[2] !== undefined &&
                mainItem.CONTENTLIST[2].DATALIST.length > 0
            "
          >
            <div
              class="divMain3"
              v-for="(item, index) in mainItem.CONTENTLIST[2].DATALIST"
              :key="index"
              v-bind:style="{
                position: 'absolute',
                top: index * (60 + 30) * 2 * 2 + (60 + 16) + 'px'
              }"
            >
              <div v-if="queryType === 'ZXC'" @click="jumpMxHandler(item.CCH)">
                <span
                  style="top: 35%;"
                  class="spanTitileTopRight"
                  v-if="
                    item.ZNWZH1.indexOf('(0)') === -1 &&
                      item.ZNWZH2.indexOf('(0)') === -1 &&
                      queryType === 'ZXC'
                  "
                >
                  {{ item.RQ.length > 6 ? item.RQ.substr(5, 9) : "" }}
                  &nbsp;
                  {{
                    item.STARTTIME.length === 0 || item.STARTTIME === "-"
                      ? item.CXH.length > 0
                        ? "场序:" + item.CXH
                        : ""
                      : item.STARTTIME
                  }}
                </span>
                <span
                  class="spanTitileBottomRight"
                  v-if="
                    item.ZNWZH1.indexOf('(0)') === -1 &&
                      item.ZNWZH2.indexOf('(0)') === -1 &&
                      queryType === 'ZXC'
                  "
                >
                  {{ item.CDH.length > 0 ? item.CDH + "号场地" : "" }}
                </span>
                <span
                  style="color:red"
                  class="spanTitileBottomLeft1"
                  v-if="
                    item.ZNWZH1.indexOf('(0)') === -1 &&
                      item.ZNWZH2.indexOf('(0)') === -1
                  "
                >
                </span>
                <span
                  style="color:red"
                  class="spanTitileBottomLeft2"
                  v-if="
                    item.ZNWZH1.indexOf('(0)') === -1 &&
                      item.ZNWZH2.indexOf('(0)') === -1
                  "
                >
                  {{ item.SSLXMC }}
                  <!-- {{ item.CCH.substr(item.CCH.length - 3, 11) }} -->
                </span>
                <span
                  style="color:red"
                  class="spanTitileBottomLeft3"
                  v-if="
                    item.ZNWZH1.indexOf('(0)') === -1 &&
                      item.ZNWZH2.indexOf('(0)') === -1
                  "
                >
                </span>
              </div>
              <div v-if="queryType === 'CJC'" @click="jumpMxHandler(item.CCH)">
                <span
                  v-bind:style="{
                    color:
                      item.BSZT === '-1'
                        ? item.ZNWZH1.indexOf('(0)') > -1 ||
                          item.ZNWZH2.indexOf('(0)') > -1
                          ? 'green'
                          : 'black'
                        : item.BSZT === '0'
                        ? 'blue'
                        : 'green',
                    top: '37%'
                  }"
                  class="spanTitileTopRight"
                >
                  {{
                    item.BSZT === "-1"
                      ? item.ZNWZH1.indexOf("(0)") > -1 ||
                        item.ZNWZH2.indexOf("(0)") > -1
                        ? item.ZNWZH1.indexOf("(0)") > -1 &&
                          item.ZNWZH2.indexOf("(0)") === -1
                          ? item.ZNWZH2 + "  " + item.RYXM2
                          : item.ZNWZH1.indexOf("(0)") === -1 &&
                            item.ZNWZH2.indexOf("(0)") > -1
                          ? item.ZNWZH1 + "  " + item.RYXM1
                          : ""
                        : "未开赛"
                      : item.BSZT === "0"
                      ? "比赛中"
                      : item.ISPF1 === "0" && item.ISPF2 === "1"
                      ? item.ZNWZH1 + "  " + item.RYXM1
                      : item.ISPF1 === "1" && item.ISPF2 === "0"
                      ? item.ZNWZH2 + "  " + item.RYXM2
                      : (item.ISPF1 === "1" && item.ISPF2 === "1") ||
                        (item.ISDCQQ1 === "1" && item.ISDCQQ2 === "1")
                      ? "双弃权"
                      : item.ZNWZH1.indexOf("(0)") > -1
                      ? item.ZNWZH2 + "  " + item.RYXM2
                      : item.ZNWZH2.indexOf("(0)") > -1
                      ? item.ZNWZH1 + "  " + item.RYXM1
                      : item.MARK1 > item.MARK2
                      ? item.ZNWZH1 + "  " + item.RYXM1
                      : item.MARK1 === item.MARK2
                      ? item.SC1 > item.SC2
                        ? item.ZNWZH1 + "  " + item.RYXM1
                        : item.SC2 > item.SC1
                        ? item.ZNWZH2 + "  " + item.RYXM2
                        : item.MARK1 > 0 || item.MARK2 > 0
                        ? "比赛中"
                        : "未开赛"
                      : item.ZNWZH2 + "  " + item.RYXM2
                  }}
                </span>
                <!-- 团体赛 比分 显示大比分 开始 -->
                <label v-if="item.SSLX.substr(1, 2) === 'T'">
                  <span
                    class="spanTitileBottomRight"
                    v-if="
                      item.ZNWZH1.indexOf('(0)') === -1 &&
                        item.ZNWZH2.indexOf('(0)') === -1
                    "
                  >
                    {{
                      (item.ISPF1 === "1" || item.ISDCQQ1 === "1"
                        ? "(" + (item.BZ === undefined ? "" : item.BZ) + "弃)"
                        : "") +
                        item.MARK1 +
                        ":" +
                        item.MARK2 +
                        (item.ISPF2 === "1" || item.ISDCQQ2 === "1"
                          ? "(" + (item.BZ === undefined ? "" : item.BZ) + "弃)"
                          : "")
                    }}
                    {{
                      item.SSLX.substr(1, 2) === "T"
                        ? ""
                        : item.MARK1 > 0 &&
                          item.MARK2 > 0 &&
                          item.MARK1 === item.MARK2
                        ? "(" + item.SC1 + ":" + item.SC2 + ")"
                        : ""
                    }}
                  </span>
                </label>
                <!-- 团体赛 比分 显示大比分 结束 -->

                <!-- 单项赛 比分 显示小比分 开始 -->
                <label v-if="item.SSLX.substr(1, 2) !== 'T'">
                  <span
                    class="spanTitileBottomRight"
                    v-if="
                      item.ZNWZH1.indexOf('(0)') === -1 &&
                        item.ZNWZH2.indexOf('(0)') === -1
                    "
                  >
                    {{
                      item.CJMXLIST != undefined && item.CJMXLIST.length > 0
                        ? item.CJMXLIST[0].ISPF1 === "1" ||
                          item.CJMXLIST[0].ISDCQQ1 === "1"
                          ? "(" + (item.BZ === undefined ? "" : item.BZ) + "弃)"
                          : ""
                        : ""
                    }}
                    <label
                      v-for="(cjMxItem, cjMxIndex) in item.CJMXLIST"
                      :key="cjMxIndex"
                    >
                      {{ +cjMxItem.MARK1 + ":" + cjMxItem.MARK2 + "  " }}
                    </label>
                    {{
                      item.CJMXLIST != undefined && item.CJMXLIST.length > 0
                        ? item.CJMXLIST[0].ISPF2 === "1" ||
                          item.CJMXLIST[0].ISDCQQ2 === "1"
                          ? "(" + (item.BZ === undefined ? "" : item.BZ) + "弃)"
                          : ""
                        : ""
                    }}
                  </span>
                </label>
                <!-- 单项赛 比分 显示小比分 结束 -->

                <span
                  style="color:red;top: 33%;"
                  class="spanTitileBottomLeft1"
                  v-if="
                    item.ZNWZH1.indexOf('(0)') === -1 &&
                      item.ZNWZH2.indexOf('(0)') === -1
                  "
                >
                  {{ item.CDH.length > 0 ? item.CDH + "号场地" : "" }}
                </span>
                <span
                  style="color:red;top: 43%;"
                  class="spanTitileBottomLeft2"
                  v-if="
                    item.ZNWZH1.indexOf('(0)') === -1 &&
                      item.ZNWZH2.indexOf('(0)') === -1
                  "
                >
                  {{ item.RQ }}&nbsp;{{
                    item.STARTTIME === "-" || item.STARTTIME.length === 0
                      ? ""
                      : item.STARTTIME
                  }}
                </span>
                <span
                  style="color:red;top: 52%;"
                  class="spanTitileBottomLeft3"
                  v-if="
                    item.ZNWZH1.indexOf('(0)') === -1 &&
                      item.ZNWZH2.indexOf('(0)') === -1
                  "
                >
                  {{ item.SSLXMC }}
                  <!-- {{ item.CCH.substr(item.CCH.length - 3, 11) }} -->
                </span>
              </div>
            </div>
          </div>
          <!-- 第3轮 结束 -->

          <!-- 从这里调整 -->
          <!-- 第4轮 开始  -->
          <div
            style="float:left"
            v-if="
              mainItem.CONTENTLIST[3] !== undefined &&
                mainItem.CONTENTLIST[3].DATALIST.length > 0
            "
          >
            <!-- v-for="(item, index) in mainItem.CONTENTLIST[3].DATALIST" -->
            <div
              class="divMain4"
              v-for="(item, index) in mainItem.CONTENTLIST[3].DATALIST"
              :key="index"
              v-bind:style="{
                position: 'absolute',
                top: index * (60 + 30) * 2 * 2 * 2 + ((60 + 16) * 2 + 15) + 'px'
              }"
            >
              <div v-if="queryType === 'ZXC'" @click="jumpMxHandler(item.CCH)">
                <span
                  style="top: 45%;"
                  class="spanTitileTopRight"
                  v-if="
                    item.ZNWZH1.indexOf('(0)') === -1 &&
                      item.ZNWZH2.indexOf('(0)') === -1 &&
                      queryType === 'ZXC'
                  "
                >
                  {{ item.RQ.length > 6 ? item.RQ.substr(5, 9) : "" }}
                  &nbsp;
                  {{
                    item.STARTTIME.length === 0 || item.STARTTIME === "-"
                      ? item.CXH.length > 0
                        ? "场序:" + item.CXH
                        : ""
                      : item.STARTTIME
                  }}
                </span>
                <span
                  class="spanTitileBottomRight"
                  v-if="
                    item.ZNWZH1.indexOf('(0)') === -1 &&
                      item.ZNWZH2.indexOf('(0)') === -1 &&
                      queryType === 'ZXC'
                  "
                >
                  {{ item.CDH.length > 0 ? item.CDH + "号场地" : "" }}
                </span>
                <span
                  style="color:red"
                  class="spanTitileBottomLeft1"
                  v-if="
                    item.ZNWZH1.indexOf('(0)') === -1 &&
                      item.ZNWZH2.indexOf('(0)') === -1
                  "
                >
                </span>
                <span
                  style="color:red;top:46%;"
                  class="spanTitileBottomLeft2"
                  v-if="
                    item.ZNWZH1.indexOf('(0)') === -1 &&
                      item.ZNWZH2.indexOf('(0)') === -1
                  "
                >
                  {{ item.SSLXMC }}
                  <!-- {{ item.CCH.substr(item.CCH.length - 3, 11) }} -->
                </span>
                <span
                  style="color:red"
                  class="spanTitileBottomLeft3"
                  v-if="
                    item.ZNWZH1.indexOf('(0)') === -1 &&
                      item.ZNWZH2.indexOf('(0)') === -1
                  "
                >
                </span>
              </div>

              <div v-if="queryType === 'CJC'" @click="jumpMxHandler(item.CCH)">
                <span
                  v-bind:style="{
                    color:
                      item.BSZT === '-1'
                        ? item.ZNWZH1.indexOf('(0)') > -1 ||
                          item.ZNWZH2.indexOf('(0)') > -1
                          ? 'green'
                          : 'black'
                        : item.BSZT === '0'
                        ? 'blue'
                        : 'green',
                    top: '43%'
                  }"
                  class="spanTitileTopRight"
                  v-if="
                    item.ZNWZH1.indexOf('(0)') === -1 &&
                      item.ZNWZH2.indexOf('(0)') === -1
                  "
                >
                  {{
                    item.BSZT === "-1"
                      ? item.ZNWZH1.indexOf("(0)") > -1 ||
                        item.ZNWZH2.indexOf("(0)") > -1
                        ? item.ZNWZH1.indexOf("(0)") > -1 &&
                          item.ZNWZH2.indexOf("(0)") === -1
                          ? item.ZNWZH2 + "  " + item.RYXM2
                          : item.ZNWZH1.indexOf("(0)") === -1 &&
                            item.ZNWZH2.indexOf("(0)") > -1
                          ? item.ZNWZH1 + "  " + item.RYXM1
                          : ""
                        : "未开赛"
                      : item.BSZT === "0"
                      ? "比赛中"
                      : item.ISPF1 === "0" && item.ISPF2 === "1"
                      ? item.ZNWZH1 + "  " + item.RYXM1
                      : item.ISPF1 === "1" && item.ISPF2 === "0"
                      ? item.ZNWZH2 + "  " + item.RYXM2
                      : (item.ISPF1 === "1" && item.ISPF2 === "1") ||
                        (item.ISDCQQ1 === "1" && item.ISDCQQ2 === "1")
                      ? "双弃权"
                      : item.ZNWZH1.indexOf("(0)") > -1
                      ? item.ZNWZH2 + "  " + item.RYXM2
                      : item.ZNWZH2.indexOf("(0)") > -1
                      ? item.ZNWZH1 + "  " + item.RYXM1
                      : item.MARK1 > item.MARK2
                      ? item.ZNWZH1 + "  " + item.RYXM1
                      : item.MARK1 === item.MARK2
                      ? item.SC1 > item.SC2
                        ? item.ZNWZH1 + "  " + item.RYXM1
                        : item.SC2 > item.SC1
                        ? item.ZNWZH2 + "  " + item.RYXM2
                        : item.MARK1 > 0 || item.MARK2 > 0
                        ? "比赛中"
                        : "未开赛"
                      : item.ZNWZH2 + "  " + item.RYXM2
                  }}
                </span>
                <!-- 团体赛 比分 显示大比分 开始 -->
                <label v-if="item.SSLX.substr(1, 2) === 'T'">
                  <span
                    class="spanTitileBottomRight"
                    v-if="
                      item.ZNWZH1.indexOf('(0)') === -1 &&
                        item.ZNWZH2.indexOf('(0)') === -1
                    "
                  >
                    {{
                      (item.ISPF1 === "1" || item.ISDCQQ1 === "1"
                        ? "(" + (item.BZ === undefined ? "" : item.BZ) + "弃)"
                        : "") +
                        item.MARK1 +
                        ":" +
                        item.MARK2 +
                        (item.ISPF2 === "1" || item.ISDCQQ2 === "1"
                          ? "(" + (item.BZ === undefined ? "" : item.BZ) + "弃)"
                          : "")
                    }}
                    {{
                      item.SSLX.substr(1, 2) === "T"
                        ? ""
                        : item.MARK1 > 0 &&
                          item.MARK2 > 0 &&
                          item.MARK1 === item.MARK2
                        ? "(" + item.SC1 + ":" + item.SC2 + ")"
                        : ""
                    }}
                  </span>
                </label>
                <!-- 团体赛 比分 显示大比分 结束 -->

                <!-- 单项赛 比分 显示小比分 开始 -->
                <label v-if="item.SSLX.substr(1, 2) !== 'T'">
                  <span
                    class="spanTitileBottomRight"
                    v-if="
                      item.ZNWZH1.indexOf('(0)') === -1 &&
                        item.ZNWZH2.indexOf('(0)') === -1
                    "
                  >
                    {{
                      item.CJMXLIST != undefined && item.CJMXLIST.length > 0
                        ? item.CJMXLIST[0].ISPF1 === "1" ||
                          item.CJMXLIST[0].ISDCQQ1 === "1"
                          ? "(" + (item.BZ === undefined ? "" : item.BZ) + "弃)"
                          : ""
                        : ""
                    }}
                    <label
                      v-for="(cjMxItem, cjMxIndex) in item.CJMXLIST"
                      :key="cjMxIndex"
                    >
                      {{ +cjMxItem.MARK1 + ":" + cjMxItem.MARK2 + "  " }}
                    </label>
                    {{
                      item.CJMXLIST != undefined && item.CJMXLIST.length > 0
                        ? item.CJMXLIST[0].ISPF2 === "1" ||
                          item.CJMXLIST[0].ISDCQQ2 === "1"
                          ? "(" + (item.BZ === undefined ? "" : item.BZ) + "弃)"
                          : ""
                        : ""
                    }}
                  </span>
                </label>
                <!-- 单项赛 比分 显示小比分 结束 -->

                <span
                  style="color:red;top:41%"
                  class="spanTitileBottomLeft1"
                  v-if="
                    item.ZNWZH1.indexOf('(0)') === -1 &&
                      item.ZNWZH2.indexOf('(0)') === -1
                  "
                >
                  {{ item.CDH.length > 0 ? item.CDH + "号场地" : "" }}
                </span>
                <span
                  style="color:red;top: 46%;"
                  class="spanTitileBottomLeft2"
                  v-if="
                    item.ZNWZH1.indexOf('(0)') === -1 &&
                      item.ZNWZH2.indexOf('(0)') === -1
                  "
                >
                  {{ item.RQ }}&nbsp;{{
                    item.STARTTIME === "-" || item.STARTTIME.length === 0
                      ? ""
                      : item.STARTTIME
                  }}
                </span>
                <span
                  style="color:red;top: 50%;"
                  class="spanTitileBottomLeft3"
                  v-if="
                    item.ZNWZH1.indexOf('(0)') === -1 &&
                      item.ZNWZH2.indexOf('(0)') === -1
                  "
                >
                  {{ item.SSLXMC }}
                  <!-- {{ item.CCH.substr(item.CCH.length - 3, 11) }} -->
                </span>
              </div>
            </div>
          </div>
          <!-- 第4轮 结束 -->
          <!-- 第5轮 开始  -->
          <div
            style="float:left"
            v-if="
              mainItem.CONTENTLIST[4] !== undefined &&
                mainItem.CONTENTLIST[4].DATALIST.length > 0
            "
          >
            <div
              class="divMain5"
              v-for="(item, index) in mainItem.CONTENTLIST[4].DATALIST"
              :key="index"
              v-bind:style="{
                position: 'absolute',
                top:
                  index * (60 + 30) * 2 * 2 * 2 * 2 +
                  ((60 + 15) * 2 * 2 + 15 * 2) +
                  16 +
                  'px'
              }"
            >
              <div v-if="queryType === 'ZXC'" @click="jumpMxHandler(item.CCH)">
                <span
                  style="top: 44%;"
                  class="spanTitileTopRight"
                  v-if="
                    item.ZNWZH1.indexOf('(0)') === -1 &&
                      item.ZNWZH2.indexOf('(0)') === -1 &&
                      queryType === 'ZXC'
                  "
                >
                  {{ item.RQ.length > 6 ? item.RQ.substr(5, 9) : "" }}
                  &nbsp;
                  {{
                    item.STARTTIME.length === 0 || item.STARTTIME === "-"
                      ? item.CXH.length > 0
                        ? "场序:" + item.CXH
                        : ""
                      : item.STARTTIME
                  }}
                </span>
                <span
                  style="top: 52%;"
                  class="spanTitileBottomRight"
                  v-if="
                    item.ZNWZH1.indexOf('(0)') === -1 &&
                      item.ZNWZH2.indexOf('(0)') === -1 &&
                      queryType === 'ZXC'
                  "
                >
                  {{ item.CDH.length > 0 ? item.CDH + "号场地" : "" }}
                </span>
                <span
                  style="color:red"
                  class="spanTitileBottomLeft1"
                  v-if="
                    item.ZNWZH1.indexOf('(0)') === -1 &&
                      item.ZNWZH2.indexOf('(0)') === -1
                  "
                >
                </span>
                <span
                  style="color:red;top:49%"
                  class="spanTitileBottomLeft2"
                  v-if="
                    item.ZNWZH1.indexOf('(0)') === -1 &&
                      item.ZNWZH2.indexOf('(0)') === -1
                  "
                >
                  {{ item.SSLXMC }}
                  <!-- {{ item.CCH.substr(item.CCH.length - 3, 11) }} -->
                </span>
                <span
                  style="color:red"
                  class="spanTitileBottomLeft3"
                  v-if="
                    item.ZNWZH1.indexOf('(0)') === -1 &&
                      item.ZNWZH2.indexOf('(0)') === -1
                  "
                >
                </span>
              </div>

              <div v-if="queryType === 'CJC'" @click="jumpMxHandler(item.CCH)">
                <span
                  v-bind:style="{
                    color:
                      item.BSZT === '-1'
                        ? item.ZNWZH1.indexOf('(0)') > -1 ||
                          item.ZNWZH2.indexOf('(0)') > -1
                          ? 'green'
                          : 'black'
                        : item.BSZT === '0'
                        ? 'blue'
                        : 'green',
                    top: '44%'
                  }"
                  class="spanTitileTopRight"
                  v-if="
                    item.ZNWZH1.indexOf('(0)') === -1 &&
                      item.ZNWZH2.indexOf('(0)') === -1
                  "
                >
                  {{
                    item.BSZT === "-1"
                      ? item.ZNWZH1.indexOf("(0)") > -1 ||
                        item.ZNWZH2.indexOf("(0)") > -1
                        ? item.ZNWZH1.indexOf("(0)") > -1 &&
                          item.ZNWZH2.indexOf("(0)") === -1
                          ? item.ZNWZH2 + "  " + item.RYXM2
                          : item.ZNWZH1.indexOf("(0)") === -1 &&
                            item.ZNWZH2.indexOf("(0)") > -1
                          ? item.ZNWZH1 + "  " + item.RYXM1
                          : ""
                        : "未开赛"
                      : item.BSZT === "0"
                      ? "比赛中"
                      : item.ISPF1 === "0" && item.ISPF2 === "1"
                      ? item.ZNWZH1 + "  " + item.RYXM1
                      : item.ISPF1 === "1" && item.ISPF2 === "0"
                      ? item.ZNWZH2 + "  " + item.RYXM2
                      : (item.ISPF1 === "1" && item.ISPF2 === "1") ||
                        (item.ISDCQQ1 === "1" && item.ISDCQQ2 === "1")
                      ? "双弃权"
                      : item.ZNWZH1.indexOf("(0)") > -1
                      ? item.ZNWZH2 + "  " + item.RYXM2
                      : item.ZNWZH2.indexOf("(0)") > -1
                      ? item.ZNWZH1 + "  " + item.RYXM1
                      : item.MARK1 > item.MARK2
                      ? item.ZNWZH1 + "  " + item.RYXM1
                      : item.MARK1 === item.MARK2
                      ? item.SC1 > item.SC2
                        ? item.ZNWZH1 + "  " + item.RYXM1
                        : item.SC2 > item.SC1
                        ? item.ZNWZH2 + "  " + item.RYXM2
                        : item.MARK1 > 0 || item.MARK2 > 0
                        ? "比赛中"
                        : "未开赛"
                      : item.ZNWZH2 + "  " + item.RYXM2
                  }}
                </span>
                <!-- 团体赛 比分 显示大比分 开始 -->
                <label v-if="item.SSLX.substr(1, 2) === 'T'">
                  <span
                    class="spanTitileBottomRight"
                    v-if="
                      item.ZNWZH1.indexOf('(0)') === -1 &&
                        item.ZNWZH2.indexOf('(0)') === -1
                    "
                  >
                    {{
                      (item.ISPF1 === "1" || item.ISDCQQ1 === "1"
                        ? "(" + (item.BZ === undefined ? "" : item.BZ) + "弃)"
                        : "") +
                        item.MARK1 +
                        ":" +
                        item.MARK2 +
                        (item.ISPF2 === "1" || item.ISDCQQ2 === "1"
                          ? "(" + (item.BZ === undefined ? "" : item.BZ) + "弃)"
                          : "")
                    }}
                    {{
                      item.SSLX.substr(1, 2) === "T"
                        ? ""
                        : item.MARK1 > 0 &&
                          item.MARK2 > 0 &&
                          item.MARK1 === item.MARK2
                        ? "(" + item.SC1 + ":" + item.SC2 + ")"
                        : ""
                    }}
                  </span>
                </label>
                <!-- 团体赛 比分 显示大比分 结束 -->

                <!-- 单项赛 比分 显示小比分 开始 -->
                <label v-if="item.SSLX.substr(1, 2) !== 'T'">
                  <span
                    class="spanTitileBottomRight"
                    v-if="
                      item.ZNWZH1.indexOf('(0)') === -1 &&
                        item.ZNWZH2.indexOf('(0)') === -1
                    "
                  >
                    {{
                      item.CJMXLIST != undefined && item.CJMXLIST.length > 0
                        ? item.CJMXLIST[0].ISPF1 === "1" ||
                          item.CJMXLIST[0].ISDCQQ1 === "1"
                          ? "(" + (item.BZ === undefined ? "" : item.BZ) + "弃)"
                          : ""
                        : ""
                    }}
                    <label
                      v-for="(cjMxItem, cjMxIndex) in item.CJMXLIST"
                      :key="cjMxIndex"
                    >
                      {{ +cjMxItem.MARK1 + ":" + cjMxItem.MARK2 + "  " }}
                    </label>
                    {{
                      item.CJMXLIST != undefined && item.CJMXLIST.length > 0
                        ? item.CJMXLIST[0].ISPF2 === "1" ||
                          item.CJMXLIST[0].ISDCQQ2 === "1"
                          ? "(" + (item.BZ === undefined ? "" : item.BZ) + "弃)"
                          : ""
                        : ""
                    }}
                  </span>
                </label>
                <!-- 单项赛 比分 显示小比分 结束 -->

                <span
                  style="color:red;top: 45%;"
                  class="spanTitileBottomLeft1"
                  v-if="
                    item.ZNWZH1.indexOf('(0)') === -1 &&
                      item.ZNWZH2.indexOf('(0)') === -1
                  "
                >
                  {{ item.CDH.length > 0 ? item.CDH + "号场地" : "" }}
                </span>
                <span
                  style="color:red;top: 49%;"
                  class="spanTitileBottomLeft2"
                  v-if="
                    item.ZNWZH1.indexOf('(0)') === -1 &&
                      item.ZNWZH2.indexOf('(0)') === -1
                  "
                >
                  {{ item.RQ }}&nbsp;{{
                    item.STARTTIME === "-" || item.STARTTIME.length === 0
                      ? ""
                      : item.STARTTIME
                  }}
                </span>
                <span
                  style="color:red;top: 52%;"
                  class="spanTitileBottomLeft3"
                  v-if="
                    item.ZNWZH1.indexOf('(0)') === -1 &&
                      item.ZNWZH2.indexOf('(0)') === -1
                  "
                >
                  {{ item.SSLXMC }}
                  <!-- {{ item.CCH.substr(item.CCH.length - 3, 11) }} -->
                </span>
              </div>
            </div>
          </div>
          <!-- 第5轮 结束 -->
          <!-- 第6轮 开始  -->
          <div
            style="float:left"
            v-if="
              mainItem.CONTENTLIST[5] !== undefined &&
                mainItem.CONTENTLIST[5].DATALIST.length > 0
            "
          >
            <div
              class="divMain6"
              v-for="(item, index) in mainItem.CONTENTLIST[5].DATALIST"
              :key="index"
              v-bind:style="{
                position: 'absolute',
                top:
                  index * (60 + 30) * 2 * 2 * 2 * 2 * 2 +
                  ((60 + 15) * 2 * 2 * 2 + 15 * 2 + 77) +
                  'px'
              }"
            >
              <div v-if="queryType === 'ZXC'" @click="jumpMxHandler(item.CCH)">
                <span
                  style="top: 46%;"
                  class="spanTitileTopRight"
                  v-if="
                    item.ZNWZH1.indexOf('(0)') === -1 &&
                      item.ZNWZH2.indexOf('(0)') === -1 &&
                      queryType === 'ZXC'
                  "
                >
                  {{ item.RQ.length > 6 ? item.RQ.substr(5, 9) : "" }}
                  &nbsp;
                  {{
                    item.STARTTIME.length === 0 || item.STARTTIME === "-"
                      ? item.CXH.length > 0
                        ? "场序:" + item.CXH
                        : ""
                      : item.STARTTIME
                  }}
                </span>
                <span
                  class="spanTitileBottomRight"
                  v-if="
                    item.ZNWZH1.indexOf('(0)') === -1 &&
                      item.ZNWZH2.indexOf('(0)') === -1 &&
                      queryType === 'ZXC'
                  "
                >
                  {{ item.CDH.length > 0 ? item.CDH + "号场地" : "" }}
                </span>
                <span
                  style="color:red"
                  class="spanTitileBottomLeft1"
                  v-if="
                    item.ZNWZH1.indexOf('(0)') === -1 &&
                      item.ZNWZH2.indexOf('(0)') === -1
                  "
                >
                </span>
                <span
                  style="color:red;top:49%"
                  class="spanTitileBottomLeft2"
                  v-if="
                    item.ZNWZH1.indexOf('(0)') === -1 &&
                      item.ZNWZH2.indexOf('(0)') === -1
                  "
                >
                  {{ item.SSLXMC }}
                  <!-- {{ item.CCH.substr(item.CCH.length - 3, 11) }} -->
                </span>
                <span
                  style="color:red"
                  class="spanTitileBottomLeft3"
                  v-if="
                    item.ZNWZH1.indexOf('(0)') === -1 &&
                      item.ZNWZH2.indexOf('(0)') === -1
                  "
                >
                </span>
              </div>

              <div v-if="queryType === 'CJC'" @click="jumpMxHandler(item.CCH)">
                <span
                  v-bind:style="{
                    color:
                      item.BSZT === '-1'
                        ? item.ZNWZH1.indexOf('(0)') > -1 ||
                          item.ZNWZH2.indexOf('(0)') > -1
                          ? 'green'
                          : 'black'
                        : item.BSZT === '0'
                        ? 'blue'
                        : 'green',
                    top: '46%'
                  }"
                  class="spanTitileTopRight"
                  v-if="
                    item.ZNWZH1.indexOf('(0)') === -1 &&
                      item.ZNWZH2.indexOf('(0)') === -1
                  "
                >
                  {{
                    item.BSZT === "-1"
                      ? item.ZNWZH1.indexOf("(0)") > -1 ||
                        item.ZNWZH2.indexOf("(0)") > -1
                        ? item.ZNWZH1.indexOf("(0)") > -1 &&
                          item.ZNWZH2.indexOf("(0)") === -1
                          ? item.ZNWZH2 + "  " + item.RYXM2
                          : item.ZNWZH1.indexOf("(0)") === -1 &&
                            item.ZNWZH2.indexOf("(0)") > -1
                          ? item.ZNWZH1 + "  " + item.RYXM1
                          : ""
                        : "未开赛"
                      : item.BSZT === "0"
                      ? "比赛中"
                      : item.ISPF1 === "0" && item.ISPF2 === "1"
                      ? item.ZNWZH1 + "  " + item.RYXM1
                      : item.ISPF1 === "1" && item.ISPF2 === "0"
                      ? item.ZNWZH2 + "  " + item.RYXM2
                      : (item.ISPF1 === "1" && item.ISPF2 === "1") ||
                        (item.ISDCQQ1 === "1" && item.ISDCQQ2 === "1")
                      ? "双弃权"
                      : item.ZNWZH1.indexOf("(0)") > -1
                      ? item.ZNWZH2 + "  " + item.RYXM2
                      : item.ZNWZH2.indexOf("(0)") > -1
                      ? item.ZNWZH1 + "  " + item.RYXM1
                      : item.MARK1 > item.MARK2
                      ? item.ZNWZH1 + "  " + item.RYXM1
                      : item.MARK1 === item.MARK2
                      ? item.SC1 > item.SC2
                        ? item.ZNWZH1 + "  " + item.RYXM1
                        : item.SC2 > item.SC1
                        ? item.ZNWZH2 + "  " + item.RYXM2
                        : item.MARK1 > 0 || item.MARK2 > 0
                        ? "比赛中"
                        : "未开赛"
                      : item.ZNWZH2 + "  " + item.RYXM2
                  }}
                </span>
                <!-- 团体赛 比分 显示大比分 开始 -->
                <label v-if="item.SSLX.substr(1, 2) === 'T'">
                  <span
                    class="spanTitileBottomRight"
                    v-if="
                      item.ZNWZH1.indexOf('(0)') === -1 &&
                        item.ZNWZH2.indexOf('(0)') === -1
                    "
                  >
                    {{
                      (item.ISPF1 === "1" || item.ISDCQQ1 === "1"
                        ? "(" + (item.BZ === undefined ? "" : item.BZ) + "弃)"
                        : "") +
                        item.MARK1 +
                        ":" +
                        item.MARK2 +
                        (item.ISPF2 === "1" || item.ISDCQQ2 === "1"
                          ? "(" + (item.BZ === undefined ? "" : item.BZ) + "弃)"
                          : "")
                    }}
                    {{
                      item.SSLX.substr(1, 2) === "T"
                        ? ""
                        : item.MARK1 > 0 &&
                          item.MARK2 > 0 &&
                          item.MARK1 === item.MARK2
                        ? "(" + item.SC1 + ":" + item.SC2 + ")"
                        : ""
                    }}
                  </span>
                </label>
                <!-- 团体赛 比分 显示大比分 结束 -->

                <!-- 单项赛 比分 显示小比分 开始 -->
                <label v-if="item.SSLX.substr(1, 2) !== 'T'">
                  <span
                    class="spanTitileBottomRight"
                    v-if="
                      item.ZNWZH1.indexOf('(0)') === -1 &&
                        item.ZNWZH2.indexOf('(0)') === -1
                    "
                  >
                    {{
                      item.CJMXLIST != undefined && item.CJMXLIST.length > 0
                        ? item.CJMXLIST[0].ISPF1 === "1" ||
                          item.CJMXLIST[0].ISDCQQ1 === "1"
                          ? "(" + (item.BZ === undefined ? "" : item.BZ) + "弃)"
                          : ""
                        : ""
                    }}
                    <label
                      v-for="(cjMxItem, cjMxIndex) in item.CJMXLIST"
                      :key="cjMxIndex"
                    >
                      {{ +cjMxItem.MARK1 + ":" + cjMxItem.MARK2 + "  " }}
                    </label>
                    {{
                      item.CJMXLIST != undefined && item.CJMXLIST.length > 0
                        ? item.CJMXLIST[0].ISPF2 === "1" ||
                          item.CJMXLIST[0].ISDCQQ2 === "1"
                          ? "(" + (item.BZ === undefined ? "" : item.BZ) + "弃)"
                          : ""
                        : ""
                    }}
                  </span>
                </label>
                <!-- 单项赛 比分 显示小比分 结束 -->

                <span
                  style="color:red;top: 46%;"
                  class="spanTitileBottomLeft1"
                  v-if="
                    item.ZNWZH1.indexOf('(0)') === -1 &&
                      item.ZNWZH2.indexOf('(0)') === -1
                  "
                >
                  {{ item.CDH.length > 0 ? item.CDH + "号场地" : "" }}
                </span>
                <span
                  style="color:red;top: 49%;"
                  class="spanTitileBottomLeft2"
                  v-if="
                    item.ZNWZH1.indexOf('(0)') === -1 &&
                      item.ZNWZH2.indexOf('(0)') === -1
                  "
                >
                  {{ item.RQ }}&nbsp;{{
                    item.STARTTIME === "-" || item.STARTTIME.length === 0
                      ? ""
                      : item.STARTTIME
                  }}
                </span>
                <span
                  style="color:red;top: 53%;"
                  class="spanTitileBottomLeft3"
                  v-if="
                    item.ZNWZH1.indexOf('(0)') === -1 &&
                      item.ZNWZH2.indexOf('(0)') === -1
                  "
                >
                  {{ item.SSLXMC }}
                  <!-- {{ item.CCH.substr(item.CCH.length - 3, 11) }} -->
                </span>
              </div>
            </div>
          </div>
          <!-- 第6轮 结束 -->

          <!-- 第7轮 开始 -->
          <div
            style="float:left"
            v-if="
              mainItem.CONTENTLIST[6] !== undefined &&
                mainItem.CONTENTLIST[6].DATALIST.length > 0
            "
          >
            <div
              class="divMain7"
              v-for="(item, index) in mainItem.CONTENTLIST[6].DATALIST"
              :key="index"
              v-bind:style="{
                position: 'absolute',
                top:
                  index * (60 + 30) * 2 * 2 * 2 * 2 * 2 +
                  ((60 + 15) * 2 * 2 * 2 * 2 + 15 * 2 + 77 * 2) +
                  43 +
                  'px'
              }"
            >
              <div v-if="queryType === 'ZXC'" @click="jumpMxHandler(item.CCH)">
                <span
                  style="top: 49%;"
                  class="spanTitileTopRight"
                  v-if="
                    item.ZNWZH1.indexOf('(0)') === -1 &&
                      item.ZNWZH2.indexOf('(0)') === -1 &&
                      queryType === 'ZXC'
                  "
                >
                  {{ item.RQ.length > 6 ? item.RQ.substr(5, 9) : "" }}
                  &nbsp;
                  {{
                    item.STARTTIME.length === 0 || item.STARTTIME === "-"
                      ? item.CXH.length > 0
                        ? "场序:" + item.CXH
                        : ""
                      : item.STARTTIME
                  }}
                </span>
                <span
                  style="top: 51%;"
                  class="spanTitileBottomRight"
                  v-if="
                    item.ZNWZH1.indexOf('(0)') === -1 &&
                      item.ZNWZH2.indexOf('(0)') === -1 &&
                      queryType === 'ZXC'
                  "
                >
                  {{ item.CDH.length > 0 ? item.CDH + "号场地" : "" }}
                </span>
                <span
                  style="color:red"
                  class="spanTitileBottomLeft1"
                  v-if="
                    item.ZNWZH1.indexOf('(0)') === -1 &&
                      item.ZNWZH2.indexOf('(0)') === -1
                  "
                >
                </span>
                <span
                  style="color:red;top: 50%;"
                  class="spanTitileBottomLeft2"
                  v-if="
                    item.ZNWZH1.indexOf('(0)') === -1 &&
                      item.ZNWZH2.indexOf('(0)') === -1
                  "
                >
                  {{ item.SSLXMC }}
                  <!-- {{ item.CCH.substr(item.CCH.length - 3, 11) }} -->
                </span>
                <span
                  style="color:red"
                  class="spanTitileBottomLeft3"
                  v-if="
                    item.ZNWZH1.indexOf('(0)') === -1 &&
                      item.ZNWZH2.indexOf('(0)') === -1
                  "
                >
                </span>
              </div>
              <div v-if="queryType === 'CJC'" @click="jumpMxHandler(item.CCH)">
                <span
                  v-bind:style="{
                    color:
                      item.BSZT === '-1'
                        ? item.ZNWZH1.indexOf('(0)') > -1 ||
                          item.ZNWZH2.indexOf('(0)') > -1
                          ? 'green'
                          : 'black'
                        : item.BSZT === '0'
                        ? 'blue'
                        : 'green',
                    top: '49%'
                  }"
                  class="spanTitileTopRight"
                  v-if="
                    item.ZNWZH1.indexOf('(0)') === -1 &&
                      item.ZNWZH2.indexOf('(0)') === -1
                  "
                >
                  {{
                    item.BSZT === "-1"
                      ? item.ZNWZH1.indexOf("(0)") > -1 ||
                        item.ZNWZH2.indexOf("(0)") > -1
                        ? item.ZNWZH1.indexOf("(0)") > -1 &&
                          item.ZNWZH2.indexOf("(0)") === -1
                          ? item.ZNWZH2 + "  " + item.RYXM2
                          : item.ZNWZH1.indexOf("(0)") === -1 &&
                            item.ZNWZH2.indexOf("(0)") > -1
                          ? item.ZNWZH1 + "  " + item.RYXM1
                          : ""
                        : "未开赛"
                      : item.BSZT === "0"
                      ? "比赛中"
                      : item.ISPF1 === "0" && item.ISPF2 === "1"
                      ? item.ZNWZH1 + "  " + item.RYXM1
                      : item.ISPF1 === "1" && item.ISPF2 === "0"
                      ? item.ZNWZH2 + "  " + item.RYXM2
                      : (item.ISPF1 === "1" && item.ISPF2 === "1") ||
                        (item.ISDCQQ1 === "1" && item.ISDCQQ2 === "1")
                      ? "双弃权"
                      : item.ZNWZH1.indexOf("(0)") > -1
                      ? item.ZNWZH2 + "  " + item.RYXM2
                      : item.ZNWZH2.indexOf("(0)") > -1
                      ? item.ZNWZH1 + "  " + item.RYXM1
                      : item.MARK1 > item.MARK2
                      ? item.ZNWZH1 + "  " + item.RYXM1
                      : item.MARK1 === item.MARK2
                      ? item.SC1 > item.SC2
                        ? item.ZNWZH1 + "  " + item.RYXM1
                        : item.SC2 > item.SC1
                        ? item.ZNWZH2 + "  " + item.RYXM2
                        : item.MARK1 > 0 || item.MARK2 > 0
                        ? "比赛中"
                        : "未开赛"
                      : item.ZNWZH2 + "  " + item.RYXM2
                  }}
                </span>
                <!-- 团体赛 比分 显示大比分 开始 -->
                <label v-if="item.SSLX.substr(1, 2) === 'T'">
                  <span
                    style="top: 51%;"
                    class="spanTitileBottomRight"
                    v-if="
                      item.ZNWZH1.indexOf('(0)') === -1 &&
                        item.ZNWZH2.indexOf('(0)') === -1
                    "
                  >
                    {{
                      (item.ISPF1 === "1" || item.ISDCQQ1 === "1"
                        ? "(" + (item.BZ === undefined ? "" : item.BZ) + "弃)"
                        : "") +
                        item.MARK1 +
                        ":" +
                        item.MARK2 +
                        (item.ISPF2 === "1" || item.ISDCQQ2 === "1"
                          ? "(" + (item.BZ === undefined ? "" : item.BZ) + "弃)"
                          : "")
                    }}
                    {{
                      item.SSLX.substr(1, 2) === "T"
                        ? ""
                        : item.MARK1 > 0 &&
                          item.MARK2 > 0 &&
                          item.MARK1 === item.MARK2
                        ? "(" + item.SC1 + ":" + item.SC2 + ")"
                        : ""
                    }}
                  </span>
                </label>
                <!-- 团体赛 比分 显示大比分 结束 -->

                <!-- 单项赛 比分 显示小比分 开始 -->
                <label v-if="item.SSLX.substr(1, 2) !== 'T'">
                  <span
                    style="top: 51%;"
                    class="spanTitileBottomRight"
                    v-if="
                      item.ZNWZH1.indexOf('(0)') === -1 &&
                        item.ZNWZH2.indexOf('(0)') === -1
                    "
                  >
                    {{
                      item.CJMXLIST != undefined && item.CJMXLIST.length > 0
                        ? item.CJMXLIST[0].ISPF1 === "1" ||
                          item.CJMXLIST[0].ISDCQQ1 === "1"
                          ? "(" + (item.BZ === undefined ? "" : item.BZ) + "弃)"
                          : ""
                        : ""
                    }}
                    <label
                      v-for="(cjMxItem, cjMxIndex) in item.CJMXLIST"
                      :key="cjMxIndex"
                    >
                      {{ +cjMxItem.MARK1 + ":" + cjMxItem.MARK2 + "  " }}
                    </label>
                    {{
                      item.CJMXLIST != undefined && item.CJMXLIST.length > 0
                        ? item.CJMXLIST[0].ISPF2 === "1" ||
                          item.CJMXLIST[0].ISDCQQ2 === "1"
                          ? "(" + (item.BZ === undefined ? "" : item.BZ) + "弃)"
                          : ""
                        : ""
                    }}
                  </span>
                </label>
                <!-- 单项赛 比分 显示小比分 结束 -->

                <span
                  style="color:red;top: 49%;"
                  class="spanTitileBottomLeft1"
                  v-if="
                    item.ZNWZH1.indexOf('(0)') === -1 &&
                      item.ZNWZH2.indexOf('(0)') === -1
                  "
                >
                  {{ item.CDH.length > 0 ? item.CDH + "号场地" : "" }}
                </span>
                <span
                  style="color:red;top: 50%;"
                  class="spanTitileBottomLeft2"
                  v-if="
                    item.ZNWZH1.indexOf('(0)') === -1 &&
                      item.ZNWZH2.indexOf('(0)') === -1
                  "
                >
                  {{ item.RQ }}&nbsp;{{
                    item.STARTTIME === "-" || item.STARTTIME.length === 0
                      ? ""
                      : item.STARTTIME
                  }}
                </span>
                <span
                  style="color:red;top: 51%;"
                  class="spanTitileBottomLeft3"
                  v-if="
                    item.ZNWZH1.indexOf('(0)') === -1 &&
                      item.ZNWZH2.indexOf('(0)') === -1
                  "
                >
                  {{ item.SSLXMC }}
                  <!-- {{ item.CCH.substr(item.CCH.length - 3, 11) }} -->
                </span>
              </div>
            </div>
          </div>
          <!-- 第7轮 开始 -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "TtsViewCom",
  components: {},
  props: {
    queryType: {
      type: String,
      default: ""
    },
    resultList: {
      type: Array,
      default: null
    },
    ssid: {
      type: String,
      default: ""
    }
  },
  data() {
    return {};
  },
  methods: {
    jumpMxHandler(CCH) {
      if (CCH === undefined || CCH.length === 0) {
        return;
      }
      this.$router.push({
        path: "/ssbfIndex",
        query: { ssid: this.ssid, jmdparam: CCH }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.spanTitileBottomLeft1 {
  position: absolute;
  right: 3px;
  top: 8%;
  font-size: 12px;
}
.spanTitileBottomLeft2 {
  position: absolute;
  right: 3px;
  top: 35%;
  font-size: 12px;
}
.spanTitileBottomLeft3 {
  position: absolute;
  right: 3px;
  top: 60%;
  font-size: 12px;
}
.spanTitileBottomRight {
  position: absolute;
  font-weight: 600;
  right: -160px;
  width: 150px;
  margin-left: 15px;
  top: 55%;
  font-size: 13px;
}
.spanTitileTopRight {
  position: absolute;
  font-weight: 600;
  right: -160px;
  width: 150px;
  margin-left: 15px;
  top: 20%;
  font-size: 13px;
}
.titleSpan1 {
  position: absolute;
  top: -21px;
  font-size: 13px;
  left: 3px;
}
.titleSpan2 {
  position: absolute;
  bottom: 0px;
  font-size: 13px;
  left: 3px;
}

.topMainDivClass {
  margin-top: 86px;
  position: relative;
  border-bottom: 1px dashed;
}
.divMain1 {
  // width: 150px; 原来的
  width: 250px;
  height: 60px;
  border-top: 1px solid;
  border-bottom: 1px solid;
  border-right: 1px solid;
}
.divMain1::after {
  content: "";
  position: absolute;
  width: 150px;
  top: 50%;
  left: 100%;
  border-top: 1px solid;
}
.divMain2 {
  width: 150px;
  height: 90px;
  border-right: 1px solid;
  position: absolute;
  // left: 150px;原来的
  left: 250px;
}
.divMain2::after {
  content: "";
  position: absolute;
  width: 150px;
  top: 50%;
  left: 100%;
  border-top: 1px solid;
}
.divMain3 {
  width: 150px;
  height: 180px;
  border-right: 1px solid;
  position: absolute;
  // left: 300px;
  left: 400px;
}
.divMain3::after {
  content: "";
  position: absolute;
  width: 150px;
  top: 50%;
  left: 100%;
  border-top: 1px solid;
}
.divMain4 {
  width: 150px;
  height: 360px;
  border-right: 1px solid;
  position: absolute;
  // left: 450px;
  left: 550px;
}
.divMain4::after {
  content: "";
  position: absolute;
  width: 150px;
  top: 50%;
  left: 100%;
  border-top: 1px solid;
}
.divMain5 {
  width: 150px;
  height: 720px;
  border-right: 1px solid;
  position: absolute;
  // left: 600px;
  left: 700px;
}
.divMain5::after {
  content: "";
  position: absolute;
  width: 150px;
  top: 50%;
  left: 100%;
  border-top: 1px solid;
}
.divMain6 {
  width: 150px;
  height: 1440px;
  border-right: 1px solid;
  position: absolute;
  // left: 750px;
  left: 850px;
}
.divMain6::after {
  content: "";
  position: absolute;
  width: 150px;
  top: 50%;
  left: 100%;
  border-top: 1px solid;
}
.divMain7 {
  width: 150px;
  height: 2880px;
  border-right: 1px solid;
  position: absolute;
  // left: 900px;
  left: 1000px;
}
.divMain7::after {
  content: "";
  position: absolute;
  width: 150px;
  top: 50%;
  left: 100%;
  border-top: 1px solid;
}
</style>



// WEBPACK FOOTER //
// src/components/commonCom/TtsViewCom.vue